<div class="mt-2">
  <ag-shr-editor-toolbar
    [title]="'Office Email Addresses'"
    (clickEdit)="officeEmailAddressesModalComponent.showModal()"
    [isEditVisible]="
      Entity.agencyContactInfoOfficeEmailAddresses | hasPermission : EntityPermissionActivityKeys.write | async
    "
  ></ag-shr-editor-toolbar>

  <ag-shr-agency-office-email-address-grid
    [emails]="emails"
    [isEditable]="false"
  ></ag-shr-agency-office-email-address-grid>
</div>

<ag-shr-modal-window
  #officeEmailAddressesModalRef
  [title]="'Add / Edit Office Email Addresses'"
  [showSaveButton]="false"
  [width]="'75%'"
  [height]="'auto'"
  [inProgress]="inProgress$ | async"
>
  <ag-shr-agency-office-email-address-grid
    [agencyId]="agencyId"
    [emails]="emails ?? []"
    (emailAddressesChange)="emailAddressesChange.emit($event)"
  ></ag-shr-agency-office-email-address-grid>
</ag-shr-modal-window>
